import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Navbar } from '../components';
import Seo from '../components/Seo';

function NotFound() {
    return (
        <div>
            <Seo
                title="Page Not Found"
                description="The page you are looking for does not exist or has been moved."
                noindex
            />
            <Navbar />
            <div className="w-full flex flex-col items-center justify-center text-center px-5 py-24 md:py-32">
                <p className="text-primary-theme font-bold text-7xl md:text-8xl leading-none">404</p>
                <h1 className="text-3xl font-semibold text-gray-700 mt-6">Page not found</h1>
                <p className="text-gray-500 mt-3 w-full md:w-1/3">
                    Sorry, the page you are looking for doesn't exist or has been moved.
                    Check the URL, or use one of the links below.
                </p>
                <div className="flex flex-col sm:flex-row justify-center items-center gap-3 mt-8">
                    <Link
                        to="/"
                        className="bg-primary-theme rounded uppercase text-white flex items-center font-semibold text-sm px-5 py-3"
                    >
                        Back to home
                    </Link>
                    <Link
                        to="/get-started"
                        className="bg-white shadow rounded uppercase text-primary-theme flex items-center font-semibold text-sm px-5 py-3"
                    >
                        Explore docs
                    </Link>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default NotFound;